/**
 * LegitGrails authenticiteitscertificaat add-on.
 *
 * Luistert in de capture-fase naar het indienen van het "add to cart"-formulier
 * van het thema. Als de klant het certificaat-vakje heeft aangevinkt, wordt het
 * certificaat-product als los artikel aan het winkelmandje toegevoegd, naast de
 * normale afhandeling van het thema (die ongewijzigd blijft).
 */
document.addEventListener(
  'submit',
  function (event) {
    var form = event.target;
    if (!form || form.tagName !== 'FORM') return;

    var isCartForm =
      (form.dataset && form.dataset.type === 'add-to-cart-form') ||
      form.hasAttribute('data-product-form') ||
      form.getAttribute('action') === '/cart/add';
    if (!isCartForm) return;

    var checkbox = form.querySelector('.legitgrails-addon__checkbox');
    if (!checkbox || !checkbox.checked) return;

    var variantId = checkbox.getAttribute('data-legitgrails-variant-id');
    if (!variantId) return;

    // keepalive: this specific product template submits as a classic (non-AJAX)
    // form post, which navigates the browser away immediately. keepalive lets
    // this fetch finish in the background instead of being cancelled by that
    // navigation.
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
      }),
      keepalive: true,
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (data) {
            console.error('LegitGrails certificaat kon niet worden toegevoegd:', data);
          });
        }
        document.dispatchEvent(new CustomEvent('legitgrails:added'));
      })
      .catch(function (err) {
        console.error('LegitGrails certificaat fout:', err);
      });
  },
  true
);
